import React, { useState, useRef } from 'react';
import PropTypes from 'prop-types';
import {
  Button,
  Grow,
  Paper,
  Popper,
  MenuItem,
  MenuList,
  Divider,
  Avatar,
  useTheme,
  useMediaQuery,
} from '@material-ui/core';
import { makeStyles } from '@material-ui/core/styles';
import ClickAwayListener from '@material-ui/core/ClickAwayListener';
import NoAvatarImage from 'public/images/no-avatar.svg';

import ChevronDownIcon from 'public/icons/chevron-down.svg';
import ChevronUpIcon from 'public/icons/chevron-up.svg';

const size = { width: 20, height: 20, marginRight: 5 };
const avatarFullSize = { width: '100%', height: '100%' };

const useStyles = makeStyles({
  root: {
    boxShadow: 'none',
    minWidth: 'fit-content',
    marginLeft: 10,
  },

  popper: {
    width: '90%',
  },

  paper: {
    borderRadius: 10,
    boxShadow: '0 0 30px 0 rgba(0, 0, 0, 0.1)',
    marginTop: '-5px',
  },

  menuList: {
    padding: '12px 10px',
  },

  button: {
    height: 40,
    width: '100%',
    justifyContent: 'space-between',
    borderBottom: '1px solid #e8fefc',
    borderRadius: 0,
    margin: '20px 0',
  },

  menuListItem: {
    display: 'flex',
    justifyContent: 'space-between',
    padding: '5px 5px',
    margin: '3px 0',
    fontFamily: 'Avenir Heavy',
    fontSize: 14,
    color: '#323643',
    textTransform: 'capitalize',

    '&:hover': {
      backgroundColor: '#e8fefc',
      borderRadius: 5,
      color: '#323643',
    },
  },

  button: {
    height: 40,
    width: '100%',
    justifyContent: 'space-between',
    borderBottom: '1px solid #5b00db',
    borderRadius: 0,
    margin: '20px 0',
  },

  text: {
    fontFamily: 'Avenir Roman',
    fontWeight: 400,
    textTransform: 'capitalize',
    color: '#323643',
  },

  endIcon: {
    marginLeft: 15,
  },
});

const zIndex = { zIndex: 99999 };
const iconStyle = {
  filter:
    'invert(50%) sepia(76%) saturate(6994%) hue-rotate(250deg) brightness(79%) contrast(125%)',
};

const OnlyFansConnectionsDropdown = ({ setSelectedItem, selectedItem, menuTitle, menuItems }) => {
  const classes = useStyles();
  const [open, setOpen] = useState(false);
  const anchorRef = useRef();

  const theme = useTheme();
  const isMobile = useMediaQuery(theme.breakpoints.down('xs'));

  const handleCloseMenu = event => {
    if (anchorRef?.current && anchorRef?.current.contains(event.target)) {
      return;
    }

    setOpen(false);
  };

  const handleClose = () => setOpen(false);

  const handleToggle = () => (open ? handleClose() : setOpen(true));

  const sortedMenuItems = [...menuItems].sort((a, b) => {
    const getPriority = item => {
      if (item.enabled && item.influencer_network_id) return 1;
      if (!item.enabled) return 0;
      return 2;
    };

    return getPriority(b) - getPriority(a);
  });

  return (
    <div className={classes.root}>
      <Button
        ref={anchorRef}
        onClick={handleToggle}
        disableRipple
        classes={{ root: classes.button, label: classes.text, endIcon: classes.endIcon }}
        endIcon={
          open ? (
            <ChevronUpIcon width={10} height={10} style={iconStyle} />
          ) : (
            <ChevronDownIcon width={10} height={10} />
          )
        }
      >
        {selectedItem.display_name || menuTitle}
      </Button>

      <Popper
        open={open}
        anchorEl={anchorRef.current}
        placement="bottom-start"
        transition
        style={zIndex}
      >
        {({ TransitionProps }) => (
          <Grow {...TransitionProps} style={isMobile ? { width: 350 } : { width: 455 }}>
            <Paper className={classes.paper}>
              <ClickAwayListener onClickAway={handleCloseMenu}>
                <MenuList className={classes.menuList}>
                  {[...sortedMenuItems].map((item, index) => (
                    <div key={index}>
                      <MenuItem
                        disabled={!item.enabled || item.influencer_network_id}
                        onClick={() => {
                          setSelectedItem(item);
                          handleClose();
                        }}
                        className={classes.menuListItem}
                      >
                        <div
                          style={{
                            width: '100%',
                            display: 'flex',
                            alignItems: 'center',
                            justifyContent: 'space-between',
                          }}
                        >
                          <div style={{ display: 'flex', alignItems: 'center' }}>
                            <Avatar src={item.background_image_url} alt="Avatar" style={size}>
                              <NoAvatarImage style={avatarFullSize} />
                            </Avatar>
                            <h4>{item.username}</h4>{' '}
                          </div>

                          <div style={{ marginLeft: 20 }}>
                            {item.enabled && !item.influencer_network_id && item.email}
                            {item.influencer_network_id && (
                              <span className="color-red">In Use</span>
                            )}

                            {!item.enabled && <span className="color-red">Disabled</span>}
                          </div>
                        </div>
                      </MenuItem>

                      {index !== menuItems.length - 1 && <Divider />}
                    </div>
                  ))}
                </MenuList>
              </ClickAwayListener>
            </Paper>
          </Grow>
        )}
      </Popper>
    </div>
  );
};

OnlyFansConnectionsDropdown.propTypes = {
  setSelectedItem: PropTypes.func.isRequired,
  menuItems: PropTypes.array.isRequired,
  menuTitle: PropTypes.oneOfType([PropTypes.string, PropTypes.object]),
  selectedItem: PropTypes.oneOfType([PropTypes.string, PropTypes.object]),
};

OnlyFansConnectionsDropdown.defaultProps = {
  menuTitle: 'Select an item',
  selectedItem: '',
};

export default OnlyFansConnectionsDropdown;
